import React, { useState, useEffect, useRef } from "react";
import "./About.css";

const profile = "/Images/Teams/Profile.jpg"; // placeholder

// ===== DATA =====
const departments = [
  {
    name: "Leadership",
    people: [
      {
        name: "Alex Yin Kyi",
        title: "Founder & President",
        img: "/Images/Teams/alex.jpg",
        bio:
          "Alex Yin Kyi is Mechanical Engineer by education. He founded Wright Brothers as a HVAC service and repair company in 2008. Keeping his strong belief in customer satisfaction, the company has contributed to multiple projects in South Florida region and is expanding the boundaries.",
      },
      {
        name: "Vishal Singh",
        title: "Director of Operations and Strategy",
        img: "/Images/Teams/team3.png",
        bio:
          "Vishal has an educational background in Civil Engineering and Construction Management. He brings with him strong experience and educational background from the construction industry.",
      },
      {
        name: "Richard Kaplan",
        title: "Project Executive",
        img: "/Images/Teams/richard.png",
        bio:
          "Richard is responsible for leading Plumbing Division and oversees multiple projects and project teams. He provides leadership on our projects from the early stages of preconstruction through the project delivery to our clients. Richard brings over twenty-two years of project experience to this role.",
      },
    ],
  },
  {
    name: "Plumbing",
    people: [
      { name: "Jason Phillips", title: "Project Manager", img: "/Images/Teams/jason2.png", bio: "Jason brings over 17 years of experience in construction and the plumbing trade, offering extensive practical knowledge and leadership. He has worked on multi-family, residential, commercial, and institutional projects, successfully leading teams to ensure quality, safety, and efficient delivery." },
      { name: "Mostafa Elalfy", title: "Project Manager", img: "/Images/Teams/Mostafa.jpg", bio: "Mostafa is a Civil Engineer with over 20 years of experience in plumbing systems. He has led major residential, commercial, and hospitality projects in the UAE and USA. At Wright Brothers Contracting Services, he oversees plumbing design, installation, and coordination, ensuring quality and timely project delivery."},
      { name: "Aashna Rahman", title: "Assistant Procurement Manager", img: "/Images/Teams/Aashna1.jpg"},
      { name: "Brooks Stanczyk", title: "Project Supervisor", img: profile },
      { name: "Nithish Venkatesh", title: "Assistant Project Manager", img: "/Images/Teams/Nithish.jpg"},
      { name: "Nandha Kumar", title: "Assistant Project Manager", img: "/Images/Teams/Nandha.jpg"},
      { name: "Cesarina Lago (Susie)", title: "Purchasing Agent", img: "/Images/Teams/Cesarina1.jpg" },
      { name: "Daniel Ocampo", title: "Field Engineer", img: "/Images/Teams/daniel.jpg"},
      { name: "Saurabh Patil", title: "Field Engineer", img: "/Images/Teams/Saurabh.jpg"},
      { name: "Vishwanth Peddi", title: "Field Engineer", img: profile },
    ],
  },
  {
    name: "HVAC",
    people: [
      { name: "Henry Florian", title: "Service Manager", img:"/Images/Teams/Henry.png" },
      { name: "Shubham Patil", title: "Assistant Project Manager", img: "/Images/Teams/Shubham.jpg" },
      { name: "Balaji Nagaraj", title: "Assistant Project Manager", img: profile },
    ],
  },
  {
    name: "Electrical",
    people: [
      { name: "Kristel Grimes", title: "Department Manager", img: "/Images/Teams/team8.png"},
    ],
  },
  {
    name: "Warehouse",
    people: [{ name: "Jose Ceredena", title: "Warehouse Manager", img: "/Images/Teams/Jose1.jpg" }],
  },
  {
    name: "HR & Accounts",
    people: [
      { name: "Sai Goriparthi", title: "Human Resources", img: "/Images/Teams/Sai1.jpg" },
      { name: "Vivan", title: "Senior Accountant", img: "/Images/Teams/Vivian1.jpg" },
    ],
  },
  {
    name: "Technical",
    people: [
      { name: "Jithin Gopinadhan", title: "Project Control Analyst", img: "/Images/Teams/Jithin.jpg" },
    ],
  },
];

export default function About() {
  const [openDept, setOpenDept] = useState("Leadership");
  const toggle = (name) => setOpenDept((prev) => (prev === name ? null : name));

  // ===== Team Carousel =====
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const trackRef = useRef(null);

  const images = [
    "/Images/Teams/team11.png",
    "/Images/Teams/team10.png",
    "/Images/Teams/teampic8.jpg",
    "/Images/Teams/teampic5.jpg",
    "/Images/Teams/team_new1.jpg",
    "/Images/Teams/teampic3.jpg",
    "/Images/Teams/teamnew3.jpg", 
    "/Images/Teams/Image (25).jpg",
  ];

  useEffect(() => {
    if (paused) return;
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4500);
    return () => clearInterval(interval);
  }, [images.length, paused]);

  useEffect(() => {
    if (trackRef.current) {
      trackRef.current.style.transform = `translateX(-${index * 100}%)`;
    }
  }, [index]);

  const prevSlide = () => setIndex((prev) => (prev - 1 + images.length) % images.length);
  const nextSlide = () => setIndex((prev) => (prev + 1) % images.length);

  // ===== Gallery Carousel (Building Together) =====
  const [index2, setIndex2] = useState(0);
  const [paused2, setPaused2] = useState(false);
  const trackRef2 = useRef(null);

  const galleryImages = [
    "/Images/Teams/heri3.jpg",
    "/Images/Teams/heri2.jpg",
    "/Images/Teams/heri1.jpg",
    "/Images/Teams/halloween_1.jpg",
  ];

  useEffect(() => {
    if (paused2) return;
    const interval = setInterval(() => {
      setIndex2((prev) => (prev + 1) % galleryImages.length);
    }, 4500);
    return () => clearInterval(interval);
  }, [galleryImages.length, paused2]);

  useEffect(() => {
    if (trackRef2.current) {
      trackRef2.current.style.transform = `translateX(-${index2 * 100}%)`;
    }
  }, [index2]);

  const prevSlide2 = () => setIndex2((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  const nextSlide2 = () => setIndex2((prev) => (prev + 1) % galleryImages.length);

  return (
    <div className="about-wrapper">
      {/* Intro */}
      <div className="about-intro">
        <h2 className="section-title">About Wright Brothers Contracting Services, Inc</h2>
        <p className="about-paragraph">
          We have been serving Florida since 2008. Our founder, Alex Yin Kyi, had worked in the industry for years and felt that customers deserved more out of the services being provided. He started Wright Brothers as a way for customers to have the best possible experience when seeking a contractor to perform work for them. Alex has spent years assembling the team of talented contractors, technicians and support staff that Wright Brothers offers. Our primary location is here in the heart of Palm Beach County, but we provide our service between Orlando and Miami. Wright Brothers has served both residential and commercial clients across all of our lines of business. We hold licensing in HVAC, Electrical, Plumbing, Mechanical, and General Contracting in addition to various certifications and accreditations. Our team prides ourselves on offering top-notch service at competitive pricing and having the ability to serve all of our customer’s needs in-house. The company is growing on the ethos of Commitment, Integrity and Reliability. Our team works with sincerity and dedication to meet the schedule of our clients. Alex has a simple philosophy towards the growth of the company : No matter the size of the project, our goal is customer satisfaction.
        </p>
        <div className="about-signature-block">
          <img src="/Images/sign.png" alt="Yin Kyi signature" className="about-signature-img" />
          <div className="about-signature-meta">
            <div className="about-signature-name">Alex Yin Kyi</div>
            <div className="about-signature-title">Founder and President</div>
          </div>
        </div>
      </div>

      {/* Team Carousel */}
      <div className="team-carousel">
        <div className="carousel-track" ref={trackRef}>
          {images.map((src, i) => (
            <img key={i} src={src} alt={`Team ${i + 1}`} />
          ))}
        </div>
        <button className="carousel-btn prev" onClick={prevSlide}>‹</button>
        <button className="carousel-btn next" onClick={nextSlide}>›</button>
        <button className="pause-btn" onClick={() => setPaused(!paused)}>
          {paused ? "▶" : "⏸"}
        </button>
      </div>

      {/* New Event Carousel */}
      <h2 className="section-title">Building Together — On and Off the Site</h2>
      <div className="team-carousel event-carousel">
        <div className="carousel-track" ref={trackRef2}>
          {galleryImages.map((src, i) => (
            <img key={i} src={src} alt={`Gallery ${i + 1}`} />
          ))}
        </div>
        <button className="carousel-btn prev" onClick={prevSlide2}>‹</button>
        <button className="carousel-btn next" onClick={nextSlide2}>›</button>
        <button className="pause-btn" onClick={() => setPaused2(!paused2)}>
          {paused2 ? "▶" : "⏸"}
        </button>
      </div>

      {/* Accordion Teams */}
      <h2 className="section-title">Our Teams</h2>
      <div className="accordion">
        {departments.map((dept) => {
          const open = openDept === dept.name;
          return (
            <div className={`accordion-item ${open ? "open" : ""}`} key={dept.name}>
              <button className="accordion-header" onClick={() => toggle(dept.name)}>
                <span style={{ textTransform: "uppercase" }}>{dept.name}</span>
                <span className="accordion-icon">{open ? "−" : "+"}</span>
              </button>
              <div className="accordion-content" style={{ display: open ? "block" : "none" }}>
                <div className="person-grid">
                  {dept.people.map((p, i) => (
                    <div key={i} className="person-card">
                      <img className="person-avatar" src={p.img} alt={p.name} />
                      <h3 className="person-name">{p.name}</h3>
                      <div className="person-title">{p.title}</div>
                      {p.bio && <p className="person-bio">{p.bio}</p>}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
